export default __webpack_public_path__ + "static/media/expl-gradcam_13_EN.1fb380c1.png";